import React from 'react';
import { createRoot } from 'react-dom/client';

import { AbbyChatBotPopup } from 'src/components/common/abby-chat/abby-chat-bot-popup';
import { userHasConsentedToAllOptionalCookieCategories } from 'src/cookies/consent-cookie';
import type { OnCookieConsentChangeArgs } from 'src/cookies/cookie-consent-banner';
import type { BuildType } from 'src/enums/build/build-type';
import { generalAllowedAllConsentCookieOnChange } from 'src/helpers/chat-helper';

const ABBY_CHAT_BOT_CLASS = 'abby-chat-popup-show';
const ABBY_CHAT_BOT_CONTAINER_ID = 'abby-chat-bot-container';
export const ABBY_CHAT_ICON_CLASS = 'show-abby-chat-icon';
export const HIDE_ABBY_CHAT_ICON_CLASS = 'hide-abby-chat-icon';
export const ABBY_CHAT_BOT_ID = 'abby-chat-bot';
export const ABBY_CHAT_ICON_ID = 'abby-chat-icon';

const updateVisibility = (
  isClose?: boolean,
  id = ABBY_CHAT_BOT_ID,
  className = ABBY_CHAT_BOT_CLASS
) => {
  if (typeof document === 'undefined') return;
  const elem = document.getElementById(id);

  if (elem) {
    if (isClose) {
      elem.classList.remove(className);
    } else {
      if (userHasConsentedToAllOptionalCookieCategories()) {
        elem.classList.add(className);
      }
    }
  }
};

const init = (buildType: BuildType) => {
  const elem = document.getElementById(ABBY_CHAT_BOT_CONTAINER_ID);
  if (elem) return;
  const botContainer = document.createElement('div');
  botContainer.id = ABBY_CHAT_BOT_CONTAINER_ID;
  document.body.appendChild(botContainer);

  const root = createRoot(botContainer);
  root.render(<AbbyChatBotPopup buildType={buildType} />);
};

const remove = () => {
  const botContainer = document.getElementById(ABBY_CHAT_BOT_CONTAINER_ID);
  if (!botContainer) return;
  document.body.removeChild(botContainer);
};

const close = () => updateVisibility(true);
const open = () => updateVisibility();

const allowedAllConsentCookieOnChange = (consentChange: OnCookieConsentChangeArgs) =>
  generalAllowedAllConsentCookieOnChange(
    `#${ABBY_CHAT_BOT_CONTAINER_ID}`,
    ABBY_CHAT_ICON_CLASS
  )(consentChange);

const abby = { open, close, init, remove, allowedAllConsentCookieOnChange };
export default abby;
